export default "__VITE_ASSET__BQHf40IM__"